module.exports = __webpack_public_path__ + "static/media/plam_mbti_main_gif.452ee64d.gif";